import { Component, Renderer2 } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { CheckGroupResquest } from 'src/app/wings-mobile/models/receiving/staging/check-group-request.model';
import { CheckStagingResquest } from 'src/app/wings-mobile/models/receiving/staging/check-staging-resquest.model';
import { ReceivingManagementGroupResponse } from 'src/app/wings-mobile/models/receiving/staging/receiving-management-group-response.model';
import { StagingRequest } from 'src/app/wings-mobile/models/receiving/staging/staging-request.model';
import { InboundService } from 'src/app/wings-mobile/services/inbound/staging.service';
import { MessageBeep } from 'src/app/wings-mobile/services/messageBeep/messageBeep.service';
import { Globals } from 'src/app/wings-mobile/shared/globals/globals';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { NgClass, NgIf } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { InputGenericComponent } from '../../../../shared/input-generic/input-generic.component';
import { AlertCustomComponent } from '../../../../shared/alert-custom/alert-custom.component';

@Component({
    selector: 'receiving',
    templateUrl: './receiving.component.html',
    styleUrls: ['./receiving.component.css'],
    imports: [FormsModule, InputTextModule, NgClass, NgIf, ButtonDirective, InputGenericComponent, AlertCustomComponent, TranslatePipe]
})
export class ReceivingComponent {

	//*************Check entry label****************/
	//PostMapping("/checkPreReceivingGroup") *******/
	//**********************************************/
	checkGroupResquest: CheckGroupResquest;
	receivingManagementGroupResponse: ReceivingManagementGroupResponse;

	//*************Check entry staging**************/
	//@PostMapping("/checkStagingLocation")  *******/
	//**********************************************/
	checkStagingResquest: CheckStagingResquest;

	//****Sent Request button Save, button Print****/
	//@PostMapping("/process")               *******/
	//@PostMapping("/process/print")         *******/
	//**********************************************/
	stagingRequest: StagingRequest;

	disabledStaging: boolean = true;
	disabledClickSave: boolean = true;
	disabledClickPrint: boolean = true;
	showAlert: boolean = false;

	errorMessage: string;
	errorFocus: string;
	errorTitle: string;

	inputFields = [
		{ name: "label", id: "label_code", focus: true, value: null, action: "this.checkLabel()", valid: false },
		{ name: "staging", id: "staging_code", focus: false, value: null, action: "this.checkStaging()", valid: false }
	]

	constructor(public globals: Globals,
		private service: InboundService,
		private renderer: Renderer2,
		private beep: MessageBeep,
		private translate: TranslateService) {
		this.renderer = renderer;
		this.globals = globals;
		this.service = service;
		this.beep = beep;
		this.translate = translate;
	}

	ngAfterViewInit() {
		this.resetScreenData();
	}

	setCheckGroupResquest() {
		this.checkGroupResquest = {
			groupLabelNum: parseInt(this.inputFields[0].value),
			userC: this.globals.user.userName,
			language: this.globals.user.language,
			requestType: "MOBILE"
		}
	}

	setStagingRequest() {
		this.checkStagingResquest = {
			stagingLabelNum: this.inputFields[1].value,
			userC: this.globals.user.userName,
			language: this.globals.user.language,
			bkWarehouseUidK: this.globals.user.warehouse.warehouseUidK
		}
		this.checkStagingResquest.stagingLabelNum = this.checkStagingResquest.stagingLabelNum.toUpperCase();
	}

	setStagingRequestPostProcess() {
		this.stagingRequest = {
			dockLabelNum: parseInt(this.inputFields[0].value),
			stagingLabelNum: this.inputFields[1].value,
			userC: this.globals.user.userName,
			language: this.globals.user.language,
			siteCode: this.globals.tokenData.fordSiteCode,
			subDivisionUidK: this.globals.user.warehouse.bkSubDivisionUidD
		}
		this.stagingRequest.stagingLabelNum = this.stagingRequest.stagingLabelNum.toUpperCase();
	}

	setStagingRequestPostProcessPrint() {
		this.stagingRequest = {
			dockLabelNum: parseInt(this.inputFields[0].value),
			stagingLabelNum: this.inputFields[1].value,
			userC: this.globals.user.userName,
			language: this.globals.user.language,
			siteCode: this.globals.tokenData.fordSiteCode,
			subDivisionUidK: this.globals.user.warehouse.bkSubDivisionUidD
		}
	}

	checkLabel() {
		if (this.inputFields[0].value) {
			this.setCheckGroupResquest();
			this.resetLabel();
			this.service.getCheckReceivingGroup(this.checkGroupResquest).subscribe({
				next: (res: ReceivingManagementGroupResponse) => {
					this.receivingManagementGroupResponse = res;

					if (res.uploadedS) {
						this.showErrorModal("modal.error", "modal.groupLabelRealized");
						this.focusInputFields("label_code", true);
						this.inputFields[1].value = res.stageLocation;
						this.disabledClickPrint = false;
					} else {
						this.focusInputFields("staging_code", true);
						this.disabledStaging = false;
						this.inputFields[0].valid = true;
						this.beep.successBeep();
					}
				},
				error: err => {
					if (typeof err.error === 'string') {
						this.showErrorModal("modal.error", err.error, "label_code");
					} else {
						this.showErrorModal("modal.error", 'modal.connectionFailed', "label_code");
					}
				}
			});
		}
	}

	checkStaging() {
		if (this.inputFields[1].value) {
			this.setStagingRequest();
			this.service.getCheckStaging(this.checkStagingResquest).subscribe({
				next: (response) => {
					// this.inputFields[0].valid = true;
					this.inputFields[1].valid = true;
					this.disabledStaging = false;
					this.disabledClickSave = false;
					this.beep.successBeep();
					this.blurInputFields('all');
				},
				error: err => {
					if (typeof err.error !== 'string') {
						this.disabledClickSave = true;
						this.showErrorModal("modal.error", 'modal.connectionFailed', "staging_code");
					} else {
						this.disabledClickSave = true;
						this.showErrorModal("modal.error", err.error, "staging_code");
					}
					this.resetStaging();
				}
			});
		}
	}

	clickSave() {
		this.setStagingRequestPostProcess();
		this.service.postProcess(this.stagingRequest).subscribe({
			next: () => {
				this.inputFields[0].valid = false;
				this.disabledClickPrint = false;
				this.disabledClickSave = true;
				this.beep.successBeep();
			},
			error: err => {
				if (typeof err.error !== 'string') {
					this.beep.showAlertCustom("modal.error", 'modal.connectionFailed', "scanner_id");
				} else {
					this.beep.showAlertCustom("modal.error", err.error, "scanner_id");
				}
			}
		});
	}

	clickPrint() {
		this.setStagingRequestPostProcessPrint();
		this.service.postProcessPrint(this.stagingRequest).subscribe({
			next: () => {
				this.beep.successBeep();
				this.resetScreenData();
			},
			error: err => {
				if (typeof err.error !== 'string') {
					this.beep.showAlertCustom("modal.error", 'modal.connectionFailed', "scanner_id");
				} else {
					if (err.error === this.translate.instant('label.alreadyPrinted')) {
						this.showErrorModal("modal.error", err.error + ". " + this.translate.instant('modal.reprintDesktop'), "label_code");
						this.resetScreenData();
					} else {
						this.beep.showAlertCustom("modal.error", err.error, "scanner_id");
					}
				}
			}
		});
		this.disabledClickPrint = true;
	}

	resetScreenData() {
		this.inputFields[0].valid = false;
		this.inputFields[0].value = null;
		this.inputFields[0].focus = true;
		this.inputFields[1].valid = false;
		this.inputFields[1].value = null;
		this.inputFields[1].focus = false;
		this.disabledStaging = true;
		this.disabledClickSave = true;
		this.disabledClickPrint = true;
		this.receivingManagementGroupResponse = null;
		this.focusZebra();
	}

	focusInputFields(elId: string = 'remove', focusZebra: boolean = false) {
		this.blurInputFields('all');

		if (focusZebra) {
			this.renderer.selectRootElement('#scanner_id').focus();
		} else {
			if (elId !== 'remove') {
				this.renderer.selectRootElement(`#${elId}`).focus();
			}
		}

		switch (elId) {
			case 'label_code':
				this.inputFields[0].focus = true;
				break;
			case 'staging_code':
				this.inputFields[1].focus = true;
				break;
			default:
				break;
		}
	}

	blurInputFields(elId: string = 'all') {
		switch (elId) {
			case 'label_code':
				this.inputFields[0].focus = false;
				break;
			case 'staging_code':
				this.inputFields[1].focus = false;
				break;
			default:
				this.inputFields.forEach(input => input.focus = false);
				break;
		}
	}

	setInputToInvalid(elId: string) {
		switch (elId) {
			case 'label_code':
				this.inputFields[0].valid = false;
				break;
			case 'staging_code':
				this.inputFields[1].valid = false;
				break;
			case 'all':
				this.inputFields.forEach(input => input.valid = false);
			default:
				break;
		}
	}

	resetLabel() {
		this.receivingManagementGroupResponse = null;
		this.disabledStaging = true;
		this.disabledClickSave = true;
		this.disabledClickPrint = true;
		this.setInputToInvalid('all');
		this.inputFields[0].valid = false;
		this.inputFields[1].value = null;
	}

	resetStaging() {
		this.inputFields[1].valid = false;
		this.inputFields[1].focus = true;
	}

	checkAbleSave(): boolean {
		let disable = false;
		this.inputFields.forEach(item => {
			if (!item.valid) {
				disable = true;
			}
		});
		return disable;
	}

	executeAction(item) {
		eval(item.action);
	}

	showErrorModal(title: string, msg: string, focus?: string) {
		this.errorTitle = this.translate.instant(title);
		this.errorMessage = this.translate.instant(msg);
		this.errorFocus = focus;
		this.showAlert = true;
		this.beep.errorBeep();
	}

	hideErrorModal(elId) {
		if (elId) {
			this.focusInputFields(elId, true);
		}
		this.setInputToInvalid(elId);
		this.inputFields.forEach(item => {
			if (item.id === elId) {
				item.value = null;
			}
		});
		this.showAlert = false;
	}

	focusZebra() {
		this.renderer.selectRootElement('#scanner_id').focus();
	}
}

